import React from 'react'

type IProps = {
  verified: boolean
  label: string
  index: number
}

const VerificationBadge = ({ verified, label, index }: IProps) => (
  <li className="flex items-center justify-between gap-4 border-t border-ink-100/15 py-4 first:border-t-0 first:pt-0">
    <div className="flex min-w-0 items-baseline gap-4">
      <span className="font-display text-[18px] leading-none font-medium tracking-[-0.01em] text-blue-500 italic md:text-[20px]">
        {String(index).padStart(2, '0')}
      </span>
      <span
        className={`truncate text-[14px] leading-snug md:text-[15px] ${
          verified ? 'text-ink-700' : 'text-ink-200'
        }`}
      >
        {label}
      </span>
    </div>
    <span
      aria-hidden="true"
      className={`flex size-6 shrink-0 items-center justify-center rounded-full border ${
        verified
          ? 'border-blue-500 bg-blue-500 text-white-500'
          : 'border-ink-100/40 text-ink-200'
      }`}
    >
      {verified ? (
        <svg
          className="size-3.5"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2.5}
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M4.5 12.75l6 6 9-13.5"
          />
        </svg>
      ) : (
        <span className="block h-px w-2.5 bg-current" />
      )}
    </span>
  </li>
)

export default React.memo(VerificationBadge)
